import React from "react";
import { NavLink } from "react-router-dom";
import { useGame } from "../context/GameContext";

export default function Navbar({ toggleTheme, theme }) {
  const { signOut } = useGame();

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <span className="brand-icon">X</span>
        <span className="brand-name">TEL<span className="brand-accent">IOUS</span></span>
      </div>
      <div className="nav-links">
        <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          HOME
        </NavLink>
        <NavLink to="/coach" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          COACH
        </NavLink>
        <NavLink to="/arsenal" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          ARSENAL
        </NavLink>
        <NavLink to="/playbook" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          PLAYBOOK
        </NavLink>
        <NavLink to="/about" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          ABOUT
        </NavLink>
      </div>
      <div className="nav-actions">
        <button className="theme-toggle" onClick={toggleTheme}>
          {theme === "dark" ? "LIGHT MODE" : "DARK MODE"}
        </button>
        <button className="nav-signout" onClick={signOut}>SIGN OUT</button>
      </div>
    </nav>
  );
}
